import _padStart from 'lodash/padStart'
// import { getCurrentTimestamp } from 'utils/ZupeeClock'
import dayjs from 'dayjs'

export const TIME_FORMAT_HOUR_MINUTE = "hh:mm A"
export const TIME_FORMAT_DAY_HOUR_MINUTE = "hh:mm A, DD MMM"

export const DIVISORS = {
  SECONDS: 1000,
  MINUTES: 1000 * 60,
  HOURS: 1000 * 60 * 60,
  DAYS: 1000 * 60 * 60 * 24
}
const _quotient = (dividend: number, divisor: number) => parseInt(String(dividend / divisor))

export const getCurrentTimestamp = () => {
  return Date.now();
};

export function formatFromNow(timestamp: number): string {
  let _delta = timestamp - getCurrentTimestamp()
  let _output = []

  let _days = _quotient(_delta, DIVISORS.DAYS)
  _delta %= DIVISORS.DAYS
  if (_days) {
    _output.push(`${_days}d`)
  }

  let _hours = _quotient(_delta, DIVISORS.HOURS)
  _delta %= DIVISORS.HOURS
  if (_hours || _output.length) {
    _output.push(`${_padStart(String(_hours), 2, '0')}h`)
  }

  let _mins = _quotient(_delta, DIVISORS.MINUTES)
  _delta %= DIVISORS.MINUTES
  if (_mins || _output.length) {
    _output.push(`${_padStart(String(_mins), 2, '0')}m`)
  }

  let _secs = _quotient(_delta, DIVISORS.SECONDS)
  _delta %= DIVISORS.SECONDS
  _output.push(`${_padStart(String(_secs), 2, '0')}s`)
  return _output.join(' ')
}

export function formatTimestamp(timestamp: number): string {
  return dayjs(timestamp).format('h:mmA')
}

export function formatTimestampTo(timeStamp: number | undefined, format: string): string {
  if (!timeStamp) return ''
  return dayjs(timeStamp).format(format)
}

//TODO This needs to be replaced with a current timestamp function using True Time

